import defaultSanitizeHtml from 'sanitize-html';

export const sanitizeHtml = (dirty: string) =>
  defaultSanitizeHtml(dirty, {
    allowedTags: [...defaultSanitizeHtml.defaults.allowedTags, 'img'],
    allowedSchemesByTag: {
      img: ['data', 'https', 'http'],
    },
    allowedAttributes: {
      ...defaultSanitizeHtml.defaults.allowedAttributes,
      '*': [
        ...(defaultSanitizeHtml.defaults.allowedAttributes['*'] ?? []),
        'style',
        'class',
        'id',
        'align',
        'border',
        'valign',
      ],
    },
  });
